const BtnLoader = () => {
  return <i className={"fa fa-spinner fa-spin"}> </i>;
};

export default BtnLoader;
